export default defineNuxtPlugin(() => {
  const {
    public: { userway },
  } = useRuntimeConfig()

  if (!userway.endpoint || !userway.id) {
    return
  }

  useHead({
    script: [
      {
        ['data-account']: userway.id,
        src: userway.endpoint,
        defer: true,
        async: true,
      },
    ],
  })
})
